import React, {useState} from 'react'
import SupportForm from './SupportForm'
import { Modal } from 'react-bootstrap'
const ReportService = ({service}) => {

  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

    console.log(service)

  return (
    <div>
      <header>
        <h3>{`Cliente: ${service.cliente}`}</h3>
      </header>
        <p>{`Fecha del servicio:${service.date}`}</p>
        <p>{`Email: ${service.email}`}</p>
        <p>{`telefono: ${service.phone}`}</p>
        <p>{`Servicio Relaizado: ${service.service}`}</p>
        <p>{`Detalle del servicio: ${service.description}`}</p>
        <row className="row">   
        <label for="imagen">Aceptado</label>
        <img id="imagen" alt='Esta Imagen No se ve' src={service.signature}/>   
        </row>
        <button className='outline-primary' onClick={handleOpenModal}>PDF</button>
        <Modal show={showModal} onHide={handleCloseModal}>
                  <Modal.Header closeButton>
                    {/* <Modal.Title>Formato de Soporte Tecnico</Modal.Title> */}
                  </Modal.Header>
                  <Modal.Body>
                    <SupportForm service={service}/>
                  </Modal.Body>
          </Modal>
    </div>
  )
}

export default ReportService